import { useTranslation } from 'react-i18next'
import { verifyCaptcha } from '@/services/captchaService'
import { toast } from 'sonner'
import { MutableRefObject } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import ReCAPTCHA from 'react-google-recaptcha'
import { FeatureFlag } from '@/app/[lng]/Classses/FetatureFlag'
import { RootState } from '../globalRedux/store'
import { useSelector } from 'react-redux'
import { cookieCaptchaEnabled } from '../utils/cookiesConsent'

export const CaptchaValidator = (
  captchaRef?: MutableRefObject<HCaptcha | ReCAPTCHA | null | undefined>
) => {
  const { t } = useTranslation()
  const featureFlags = useSelector(
    (state: RootState) => state.featureFlag?.feature_flags
  )
  const captchaType = FeatureFlag.getCaptchaType(featureFlags)
  const captchaEnabled = FeatureFlag.getNeedCaptcha(featureFlags)
  const isHcaptcha = captchaType === 'hCaptcha'

  const getToken = () => {
    if (!captchaRef?.current) {
      return null
    }

    if (captchaType === 'hCaptcha') {
      return (captchaRef?.current as HCaptcha)?.getResponse()
    } else {
      return (captchaRef?.current as ReCAPTCHA)?.getValue()
    }
  }

  const resetCaptcha = () => {
    if (captchaType === 'hCaptcha') {
      return (captchaRef?.current as HCaptcha)?.resetCaptcha()
    } else {
      return (captchaRef?.current as ReCAPTCHA)?.reset()
    }
  }

  const validateCaptcha = async (): Promise<boolean> => {
    if (!(captchaEnabled && cookieCaptchaEnabled())) {
      console.info('captcha is not enabled, skipping validation!')
      return true
    }

    const token = getToken()
    if (!token) {
      toast.warning(t('Please complete the CAPTCHA'))
      return false
    }

    const isValidToken = await verifyCaptcha(token)

    if (!isValidToken?.valid) {
      toast.warning(t('Invalid CAPTCHA token'))
      resetCaptcha()
      return false
    }

    resetCaptcha()
    return true
  }

  return { validateCaptcha, captchaEnabled, isHcaptcha, captchaType }
}
